@if (agenda.title || agenda.anchor) {
  <mb-section-headline [headline]="agenda.title" [anchor]="agenda.anchor" [theme]="'dark'"></mb-section-headline>
}

<div class="container-sm">
  @for (agendaDay of agendaDaysMap | keyvalue; track agendaDay.key; let i = $index) {
    <mb-accordion
      #accordion
      [hideIcon]="true"
      [isOpen]="agendaDay.value.isOpen"
      (toggled)="agendaDay.value.isOpen = $event"
    >
      <div accordion-header class="header">
        <h4>{{ 'DAY_N' | translate: { day: i + 1 } }}</h4>
        <div class="icon-container">
          <span class="mb-badge-small">{{ agendaDay.value.agendaItems.length }}</span>
          <span class="icon mb-icon mb-icon-down-thin"></span>
        </div>
      </div>
      <div accordion-content class="content">
        @for (agendaItem of agendaDay.value.agendaItems; track agendaItem.id) {
          <div class="agenda-item">
            <span class="time copy-s">{{ agendaItem.time }}</span>
            <div class="wrapper">
              <span
                class="copy-xl title"
                [style.color]="agendaItem.isTestDrive ? agendaItem.testDriveColor.color : 'inherit'"
                >{{ agendaItem.title }}</span
              >
              @if (agendaItem.isTestDrive) {
                <span class="copy-s badge" [style.background]="agendaItem.testDriveColor.color">{{
                  'TEST_DRIVE' | translate
                }}</span>
              }
              <div class="copy-s location">
                @if (agendaItem.icon) {
                  <span class="mb-icon d-none d-sm-block" [class]="agendaItem.icon"></span>
                }
                <span class="text">{{ agendaItem.location }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </mb-accordion>
  }
</div>
